export const amenities_flags = {
  hasParking: {
    label: "Parcheggio",
    icon: "parking",
  },
  petsAllowed: {
    label: "Animali ammessi",
    icon: "pets",
  },
  hasRestaurant: {
    label: "Ristorante",
    icon: "restaurant",
  },
  hasAccessibility: {
    label: "Accessibilità",
    icon: "accessibility",
  },
  hasChildrenServices: {
    label: "Servizi per bambini",
    icon: "children_services",
  },
  hasKitchen: {
    label: "Cucina",
    icon: "cutlery",
  },
  hasPool: {
    label: "Piscina",
    icon: "pool",
  },
  hasSpa: {
    label: "Spa e Wellness",
    icon: "spa",
  },
  hasBusinessCenter: {
    label: "Business Center",
    icon: "business_center",
  },
  hasChargingStation: {
    label: "Stazione di ricarica",
    icon: "charging",
  },
}

export function get_amenities_flags(key) {
  // try V2 syntax as is (es "hasChargingStation")
  if (amenities_flags[key] !== undefined) return amenities_flags[key]

  // try V3 syntax as is (es "has_charging_station")
  let key_v3 = key
    .split('_')
    .map((word, index) => {
      if (index === 0) return word
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
    })
    .join('')
  if (amenities_flags[key_v3] !== undefined) return amenities_flags[key_v3]

  // return key as fallback with placeholder icon
  return {
    label: key,
    icon: "symbol_vv",
  }
}